import { Button, Card, Dropdown, message, Space, Table } from "antd";
import React, { useEffect, useState } from "react";
import ListEmptyComponent from "../../components/ListEmptyComponent/ListEmptyComponent";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { isArrayNonEmpty } from "../../util/ApiHelper";
import { BUSINESS_TYPE_LABEL } from "../../util/Constant";
import { DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import EnquiryStatusTags from "../enquiries/EnquiriesStatus";
import { fetchStart, fetchSuccess } from "../../appRedux/actions";
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";

const formatDate = (createdAt) => {
  return new Date(createdAt).toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

const getBusinessTypeLabel = (targetedBusinessType) => {
  if (!targetedBusinessType) return "";

  const values = Array.isArray(targetedBusinessType)
    ? targetedBusinessType
    : [targetedBusinessType];

  return values
    .map((type) => BUSINESS_TYPE_LABEL[type] || type || "")
    .filter(Boolean)
    .join(", ");
};

const BannerPromotionList = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector(({ common }) => common);
  const [promotionsAdminData, setpromotionsAdminData] = useState(null);
  const history = useHistory();
  const navigateToDetails = (id) => {
    if (id) {
      history.push(`/broadcast-promotions/add-edit/${id}`);
    } else {
      history.push("/broadcast-promotions/add-edit");
    }
  };

  const onShowSizeChange = (current, pageSize) => {};

  const fetchPromotions = async () => {
    try {
      dispatch(fetchStart());
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/broadcastpromotions?page=1&limit=10`
      );
      const prom = response?.data?.data;
      setpromotionsAdminData(prom.rows);
    } catch (error) {
      console.error("Error fetching promotions:", error);
    } finally {
      dispatch(fetchSuccess());
    }
  };
  const deleteById = async (id) => {
    try {
      const response = await axiosInstance.delete(
        `${BASE_API_CONFIG.baseURL}/broadcastpromotions/${id}`
      );
      if (response.status === 200) {
        message.success("success", "Promotion deleted");
        await fetchPromotions();
      } else {
        message.error("error", "Failed to delete promotion");
      }
    } catch (error) {
      console.error("Error deleting promotions:", error);
    }
  };

  useEffect(() => {
    fetchPromotions();
  }, [dispatch]);

  
const columns = [
  {
    title: "Promotion Title",
    key: "Title",
    render: (record) => <div>{record?.title}</div>,
  },
  {
    title: "Banner Type",
    key: "Banner Type",
    render: (record) => <div>{record?.bannerType}</div>,
  },
  {
    title: "Party Name",
    key: "Party Name",
    render: (record) => (
      <div>{getBusinessTypeLabel(record?.targetedBusinessType)}</div>
    ),
  },
  {
    title: "Promotion Start",
    key: "Promotion Start",
    render: (record) => <div>{formatDate(record?.startDate)}</div>,
  },
  {
    title: "Promotion End",
    key: "Promotion End",
    render: (record) => <div>{formatDate(record?.endDate)}</div>,
  },
  {
    title: "Actions",
    key: "actions",
    render: (record) => (
      <div className="myexim-action-icon" onClick={(e) => e.stopPropagation()}>
        <Dropdown
          menu={{
            items: [
              {
                label: "Edit",
                key: "1",
                icon: <EditOutlined />,
                onClick: () => {
                  navigateToDetails(record?.id);
                },
              },
              {
                label: "Delete",
                key: "2",
                icon: <DeleteOutlined />,
                onClick: () => {
                  deleteById(record?.id);
                },
              },
            ],
          }}
          trigger={["click"]}
        >
          <Space>
            <MoreOutlined />
          </Space>
        </Dropdown>
      </div>
    ),
  },
];


  return (
    <Card
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            padding: "0 8px",
          }}
        >
          <div className="myexim-table-title">Broadcast Promotions</div>
          {isArrayNonEmpty(promotionsAdminData) && (
            <div style={{ paddingLeft: 15 }}>
              <Button
                type="primary"
                onClick={() => {
                  navigateToDetails();
                }}
              >
                + Create New Promotion
              </Button>
            </div>
          )}
        </div>
      }
    >
      <div>
        {isArrayNonEmpty(promotionsAdminData) ? (
          <Table
            rowClassName={(record, index) =>
              index % 2 === 0 ? "table-row-light" : "table-row-dark"
            }
            onRow={(record) => {
              return {
                onClick: (e) => {
                  if (
                    !e.target.classList.contains(
                      "ant-dropdown-menu-title-content"
                    )
                  ) {
                    navigateToDetails(record?.id);
                  }
                },
              };
            }}
            className="gx-table-responsive my-product-table myexim-table"
            rowKey={(record) => record.id}
            columns={columns}
            dataSource={promotionsAdminData}
            pagination={{
              position: ["bottomRight"],
              showSizeChanger: true,
              pageSize: 10,
              total: promotionsAdminData?.count,
              onChange: onShowSizeChange,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
            }}
          />
        ) : (
          !loading && (
            <ListEmptyComponent
              message="No Promotions available"
              onButtonClick={() => navigateToDetails()}
            />
          )
        )}
      </div>
    </Card>
  );
};

export default BannerPromotionList;
